// Format homepage post titles to remove "The Dann Chronicles: " prefix
export default function formatHomepageTitles() {
  // Check if we're on the homepage by looking for the postfeed container
  const postfeed = document.querySelector('.gh-postfeed');
  if (!postfeed) {
    return;
  }

  // Function to format titles
  const formatTitles = () => {
    const titles = document.querySelectorAll('.gh-postfeed .gh-card-title');
    
    titles.forEach(titleElement => {
      // Skip if already formatted (check for data attribute)
      if (titleElement.dataset.formatted === 'true') {
        return;
      }
      
      const originalTitle = titleElement.textContent.trim();
      
      // Remove "The Dann Chronicles: " prefix if present
      if (originalTitle.startsWith('The Dann Chronicles: ')) {
        titleElement.textContent = originalTitle.replace('The Dann Chronicles: ', '');
        titleElement.dataset.formatted = 'true';
      }
    });
  };

  // Format titles on initial load
  formatTitles();

  // Watch for new posts added by infinite scroll
  const observer = new MutationObserver(() => {
    formatTitles();
  });

  if (postfeed) {
    observer.observe(postfeed, {
      childList: true,
      subtree: true
    });
  }
}

